import * as _ from 'lodash-es';
import appConfig from '../config/app-config';

export const getUrlRelativeToPublicPath = (url?: string, publicPath: string = appConfig.publicPath || ''): string => {
    const PATH_SEPARATOR = '/';

    return url
        ? [
            _.trimEnd(publicPath, PATH_SEPARATOR),
            _.trim(
                url.replace(/^\./, ''), // Remove dot in "./" or "."
                PATH_SEPARATOR
            )
        ]
            .join(PATH_SEPARATOR)
        : publicPath;
};
